import { mapTableRows } from "../../utils";

export const rows = [
  {
    id: 1,
    client: "4 Consulting Inc",
    invoiceNo: "353514",
    invoiceDate: "23-Apr-2024",
    batch: "5032",
    invoiceAmount: 10900.0,
    paidDate: "07-Aug-2024",
    balance: 10900.0,
    age: 45,
    bucket_1_30: 10900.0,
    bucket_31_60: 10900.0,
    bucket_61_90: 0,
    bucket_91_120: 0,
    bucket_121_plus: 0,
  },
  {
    id: 2,
    client: "-",
    invoiceNo: "437342",
    invoiceDate: "10-Jun-2024",
    batch: "3532",
    invoiceAmount: null,
    paidDate: "11-Jun-2024",
    balance: 10900.0,
    age: 25,
    bucket_1_30: null,
    bucket_31_60: 10900.0,
    bucket_61_90: 0,
    bucket_91_120: 0,
    bucket_121_plus: null,
  },
  {
    id: 3,
    client: "-",
    invoiceNo: "134242",
    invoiceDate: "02-Jul-2024",
    batch: "-",
    invoiceAmount: null,
    paidDate: "21-Aug-2024",
    balance: 10900.0,
    age: 16,
    bucket_1_30: null,
    bucket_31_60: 10900.0,
    bucket_61_90: null,
    bucket_91_120: 0,
    bucket_121_plus: 0,
  },
  {
    id: "total",
    client: "Total",
    invoiceNo: "",
    invoiceDate: "",
    batch: "",
    invoiceAmount: 10900.0,
    paidDate: "",
    balance: 32700.0,
    age: 36,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 0,
    bucket_91_120: 0,
    bucket_121_plus: 0,
  },
  {
    id: 5,
    client: "Galaxy Home Furnishing",
    invoiceNo: "145446",
    invoiceDate: "16-Feb-2025",
    batch: "8524",
    invoiceAmount: null,
    paidDate: "20-Feb-2025",
    balance: null,
    age: 54,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 254650,
    bucket_91_120: 0,
    bucket_121_plus: 0,
  },
  {
    id: 6,
    client: "Anveta Inc.",
    invoiceNo: "674832",
    invoiceDate: "-",
    batch: "2356",
    invoiceAmount: 10900.0,
    paidDate: "17-Sep-2025",
    balance: 10900.0,
    age: 22,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 0,
    bucket_91_120: 0,
    bucket_121_plus: 24370,
  },
  {
    id: 7,
    client: "Callies Performance Product",
    invoiceNo: "474374",
    invoiceDate: "23-Sep-2024",
    batch: "-",
    invoiceAmount: 10900.0,
    paidDate: "25-Sep-2024",
    balance: null,
    age: 34,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 0,
    bucket_91_120: 4536560,
    bucket_121_plus: 0,
  },
  {
    id: 8,
    client: "Compunnel Inc.",
    invoiceNo: "326767",
    invoiceDate: "03-Nov-2025",
    batch: "6322",
    invoiceAmount: 14670.0,
    paidDate: "07-Dec-2025",
    balance: 12839.0,
    age: 23,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 45460,
    bucket_91_120: 0,
    bucket_121_plus: 0,
  },
  {
    id: 9,
    client: "-",
    invoiceNo: "126415",
    invoiceDate: "11-Nov-2025",
    batch: "5454",
    invoiceAmount: 8240.0,
    paidDate: "12-Nov-2025",
    balance: 8240.0,
    age: 53,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 0,
    bucket_91_120: 43450,
    bucket_121_plus: 0,
  },
  {
    id: 10,
    client: "Conquest Tech Solution Inc.",
    invoiceNo: "878586",
    invoiceDate: "21-Oct-2025",
    batch: "2246",
    invoiceAmount: null,
    paidDate: "06-Nov-2025",
    balance: null,
    age: 34,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 0,
    bucket_91_120: 0,
    bucket_121_plus: 235430,
  },
  {
    id: 11,
    client: "FredX Solution",
    invoiceNo: "374571",
    invoiceDate: "08-Apr-2025",
    batch: "8769",
    invoiceAmount: 10900.0,
    paidDate: "02-May-2025",
    balance: 10900.0,
    age: 22,
    bucket_1_30: 10900.0,
    bucket_31_60: 32700.0,
    bucket_61_90: 0,
    bucket_91_120: 0,
    bucket_121_plus: 0,
  },
];

export const columns = [
  { key: "client", label: "Client" },
  {
    key: "invoiceNo",
    label: "Invoice No",
    render: (row) => <div className="text-info">{row?.invoiceNo}</div>,
  },
  { key: "invoiceDate", label: "Invoice Date" },
  { key: "batch", label: "Batch" },
  { key: "invoiceAmount", label: "Invoice Amount" },
  { key: "paidDate", label: "Paid Date" },
  { key: "balance", label: "Balance" },
  { key: "age", label: "Age" },
  { key: "bucket_1_30", label: "1-30 (Days)" },
  { key: "bucket_31_60", label: "31-60 (Days)" },
  { key: "bucket_61_90", label: "61-90 (Days)" },
  { key: "bucket_91_120", label: "91-120 (Days)" },
  { key: "bucket_121_plus", label: "121+ (Days)" },
];
export const mappedRows = mapTableRows(rows, columns);

export const reportOptions = [
  { label: "Adjustment Summary Report", value: "adjustment_summary" },
  {
    label: "Adjustment Summary Report - Excel",
    value: "adjustment_summary_excel",
  },

  { label: "Aging Report", value: "Aging Report" },
  { label: "Aging Report - Excel", value: "aging_report_excel" },

  { label: "Cash Receipts Report", value: "cash_receipts_report" },

  { label: "Chargeback Report", value: "Chargeback Report" },

  { label: "Client Worksheet", value: "client_worksheet" },

  { label: "Collection Summary Report", value: "collection_summary_report" },
  {
    label: "Collection Summary Report - Excel",
    value: "collection_summary_report_excel",
  },

  {
    label: "Details Client Ledger - Excel",
    value: "details_client_ledger_excel",
  },

  { label: "Facility Ledger", value: "facility_ledger" },

  { label: "Intelligibility Report", value: "intelligibility_report" },
  {
    label: "Intelligibility Report - Excel",
    value: "intelligibility_report_excel",
  },

  { label: "Payment History Report", value: "payment_history_report" },
  {
    label: "Payment History Report - Excel",
    value: "payment_history_report_excel",
  },

  { label: "Purchase Summary Report", value: "Purchase Summary" },

  {
    label: "Reserve Details w/ Activity Report w/ Fee%",
    value: "Reserve Detail Report",
  },
  {
    label: "Reserve Details w/ Activity Report w/ Fee% - Excel",
    value: "reserve_details_activity_fee_excel",
  },
  {
    label: "Reserve Details w/ Activity Report",
    value: "reserve_details_activity",
  },

  { label: "Transaction Activity", value: "transaction_activity" },

  {
    label: "Transaction Report - Purchase Only",
    value: "transaction_purchase_only",
  },
  {
    label: "Transaction Report - Purchase & Collections",
    value: "transaction_purchase_collections",
  },
];
export const agingColumns = [
  { label: ["Client  Customer"] },
  { label: ["Invoice#"] },
  { label: ["Date"] },
  { label: ["Batch#"] },
  { label: ["Invoice Amount"] },
  { label: ["Paid Date"] },
  { label: ["Age"] },
  { label: ["Balance"] },
  { label: ["1-30 Days"] },
  { label: ["31-60 Days"] },
  { label: ["61-90 Days"] },
  { label: ["90-120 Days"] },
  { label: ["121+ Days"] },
];

export const agingRows = [
  {
    client: "Alpha Solutions, Inc",
    invoices: [
      {
        inv: "17101",
        date: "1/5/2026",
        paidDate: "10/15/2026",
        batch: "5031",
        amount: 14500.0,
        bal: 14500.0,
        age: 63,
        d1_30: 0,
        d31_60: 0,
        d61_90: 14500.0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "17210",
        date: "2/12/2026",
        paidDate: "6/22/2026",
        batch: "5053",
        amount: 11200.0,
        bal: 11200.0,
        age: 25,
        d1_30: 11200.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "26040110",
        date: "3/5/2026",
        paidDate: "3/15/2026",
        batch: "5069",
        amount: 9800.0,
        bal: 9800.0,
        age: 4,
        d1_30: 9800.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 35500.0,
      d1_30: 21000.0,
      d31_60: 0,
      d61_90: 14500.0,
      d91_120: 0,
      d121: 0,
    },
  },
  {
    client: "Blue Ridge Manufacturing LLC",
    invoices: [
      {
        inv: "17055",
        date: "12/1/2025",
        paidDate: "12/16/2025",
        batch: "5006",
        amount: 8400.0,
        bal: 8400.0,
        age: 99,
        d1_30: 0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 8400.0,
        d121: 0,
      },
      {
        inv: "17188",
        date: "2/8/2026",
        paidDate: "12/12/2026",
        batch: "5049",
        amount: 13300.0,
        bal: 13300.0,
        age: 29,
        d1_30: 13300.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "26040112",
        date: "3/5/2026",
        paidDate: "3/8/2026",
        batch: "5069",
        amount: 7600.0,
        bal: 7600.0,
        age: 4,
        d1_30: 7600.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 29300.0,
      d1_30: 20900.0,
      d31_60: 0,
      d61_90: 0,
      d91_120: 8400.0,
      d121: 0,
    },
  },
  {
    client: "Cornerstone Logistics Inc",
    invoices: [
      {
        inv: "26040115",
        date: "3/5/2026",
        paidDate: "5/8/2026",
        batch: "5069",
        amount: 16500.0,
        bal: 16500.0,
        age: 4,
        d1_30: 16500.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 16500.0,
      d1_30: 16500.0,
      d31_60: 0,
      d61_90: 0,
      d91_120: 0,
      d121: 0,
    },
  },
  {
    client: "Delta Workforce Solutions",
    invoices: [
      {
        inv: "17090",
        date: "1/22/2026",
        paidDate: "6/22/2026",
        batch: "5037",
        amount: 11040.0,
        bal: 11040.0,
        age: 46,
        d1_30: 0,
        d31_60: 11040.0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "26040118",
        date: "3/5/2026",
        paidDate: "3/25/2026",
        batch: "5069",
        amount: 11040.0,
        bal: 11040.0,
        age: 4,
        d1_30: 11040.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 22080.0,
      d1_30: 11040.0,
      d31_60: 11040.0,
      d61_90: 0,
      d91_120: 0,
      d121: 0,
    },
  },
  {
    client: "Eagle Point Staffing, LLC",
    invoices: [
      {
        inv: "17065",
        date: "12/5/2025",
        paidDate: "12/15/2025",
        batch: "5006",
        amount: 9100.0,
        bal: 9100.0,
        age: 95,
        d1_30: 0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 9100.0,
      },
      {
        inv: "17172",
        date: "2/5/2026",
        paidDate: "12/5/2026",
        batch: "5049",
        amount: 10450.0,
        bal: 10450.0,
        age: 32,
        d1_30: 0,
        d31_60: 10450.0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "26040120",
        date: "3/5/2026",
        paidDate: "8/5/2026",
        batch: "5069",
        amount: 9900.0,
        bal: 9900.0,
        age: 4,
        d1_30: 9900.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 29450.0,
      d1_30: 9900.0,
      d31_60: 10450.0,
      d61_90: 0,
      d91_120: 0,
      d121: 9100.0,
    },
  },
  {
    client: "Frontier Tech Group (FTG)",
    invoices: [
      {
        inv: "17048",
        date: "12/3/2025",
        paidDate: "12/6/2025",
        batch: "5006",
        amount: 8640.0,
        bal: 8640.0,
        age: 97,
        d1_30: 0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 8640.0,
      },
      {
        inv: "17195",
        date: "2/6/2026",
        paidDate: "2/16/2026",
        batch: "5049",
        amount: 10080.0,
        bal: 10080.0,
        age: 31,
        d1_30: 0,
        d31_60: 10080.0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "26040122",
        date: "3/5/2026",
        paidDate: "3/15/2026",
        batch: "5069",
        amount: 9600.0,
        bal: 9600.0,
        age: 4,
        d1_30: 9600.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 28320.0,
      d1_30: 9600.0,
      d31_60: 10080.0,
      d61_90: 0,
      d91_120: 0,
      d121: 8640.0,
    },
  },
  {
    client: "Granite Peak Consulting",
    invoices: [
      {
        inv: "17135",
        date: "1/18/2026",
        paidDate: "1/28/2026",
        batch: "5037",
        amount: 27500.0,
        bal: 27500.0,
        age: 50,
        d1_30: 0,
        d31_60: 27500.0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 27500.0,
      d1_30: 0,
      d31_60: 27500.0,
      d61_90: 0,
      d91_120: 0,
      d121: 0,
    },
  },
  {
    client: "Harbor View Services LLC",
    invoices: [
      {
        inv: "17099",
        date: "1/14/2026",
        paidDate: "1/18/2026",
        batch: "5037",
        amount: 11760.0,
        bal: 11760.0,
        age: 54,
        d1_30: 0,
        d31_60: 11760.0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "17220",
        date: "2/11/2026",
        paidDate: "2/12/2026",
        batch: "5053",
        amount: 11220.0,
        bal: 11220.0,
        age: 26,
        d1_30: 11220.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 22980.0,
      d1_30: 11220.0,
      d31_60: 11760.0,
      d61_90: 0,
      d91_120: 0,
      d121: 0,
    },
  },
  {
    client: "Ironside Global Ventures",
    invoices: [
      {
        inv: "17080",
        date: "2/3/2026",
        paidDate: "3/3/2026",
        batch: "5049",
        amount: 10560.0,
        bal: 10560.0,
        age: 34,
        d1_30: 0,
        d31_60: 10560.0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
      {
        inv: "26040125",
        date: "3/5/2026",
        paidDate: "3/5/2027",
        batch: "5069",
        amount: 10560.0,
        bal: 10560.0,
        age: 4,
        d1_30: 10560.0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 0,
      },
    ],
    total: {
      bal: 21120.0,
      d1_30: 10560.0,
      d31_60: 10560.0,
      d61_90: 0,
      d91_120: 0,
      d121: 0,
    },
  },
  {
    client: "JBK Professional Services",
    invoices: [
      {
        inv: "17042",
        date: "12/2/2025",
        paidDate: "11/09/2026",
        batch: "5006",
        amount: 11100.0,
        bal: 11100.0,
        age: 98,
        d1_30: 0,
        d31_60: 0,
        d61_90: 0,
        d91_120: 0,
        d121: 11100.0,
      },
    ],
    total: {
      bal: 11100.0,
      d1_30: 0,
      d31_60: 0,
      d61_90: 0,
      d91_120: 0,
      d121: 11100.0,
    },
  },
];
export const reservedColumns = [
  { label: ["Date"] },
  { label: ["Type"] },
  { label: ["Description"] },
  { label: ["Invoice#"] },
  { label: ["Reference"] },
  { label: ["Customer"] },
  { label: ["Buy Date"] },
  { label: ["Days Open"] },
  // { label: ["Days", "Open"] },
  { label: ["Activity Type"] },
  { label: ["Applied To A/R"] },
  { label: ["Applied To Advance"] },
  { label: ["Applied To Fee"] },
  { label: ["Fee%"] },
  { label: ["Reserve Amount"] },
];

export const reservedRows = [
  {
    date: "12/12/2024",
    type: "Cash",
    description: "Payment Reports",
    invoiceNo: "#16841",
    reference: "",
    rows: [
      {
        invoiceNo: "#16841",
        reference: "z216113",
        customer: "Phone Infotech",
        buyDate: "12/12/2024",
        daysOpen: 23,
        activityType: "Pmt",
        appliedAR: 14385.0,
        appliedAdvance: 12946.5,
        appliedFee: 124.07,
        feePct: 0.86,
        reserveAmount: -124.07,
      },
      {
        invoiceNo: "#16841",
        reference: "z216113",
        customer: "Phone Infotech",
        buyDate: "12/12/2024",
        daysOpen: 23,
        activityType: "O/P",
        appliedAR: 14385.0,
        appliedAdvance: 14385.0,
        appliedFee: 124.07,
        feePct: 0.86,
        reserveAmount: -124.07,
      },
      {
        invoiceNo: "#16841",
        reference: "z216113",
        customer: "Phone Infotech",
        buyDate: "12/12/2024",
        daysOpen: 23,
        activityType: "N/F",
        appliedAR: 14385.0,
        appliedAdvance: 14385.0,
        appliedFee: 124.07,
        feePct: 0.86,
        reserveAmount: -124.07,
      },
    ],
    total: {
      appliedAR: 43155.0,
      appliedAdvance: 41716.5,
      appliedFee: 372.21,
      reserveAmount: -372.21,
    },
  },
  {
    date: "12/15/2024",
    type: "Buy",
    description: "Sale",
    invoiceNo: "#5028",
    reference: "24202",
    rows: [
      {
        invoiceNo: "#5028",
        reference: "24202",
        customer: "TechVision Ltd",
        buyDate: "12/15/2024",
        daysOpen: 0,
        activityType: "Held",
        appliedAR: 0.0,
        appliedAdvance: 0.0,
        appliedFee: 0.0,
        feePct: 0.86,
        reserveAmount: 18117.1,
      },
    ],
    total: {
      appliedAR: 0.0,
      appliedAdvance: 0.0,
      appliedFee: 0.0,
      reserveAmount: 18117.1,
    },
  },
  {
    date: "12/18/2024",
    type: "Cash",
    description: "Wire Transfer",
    invoiceNo: "#17002",
    reference: "WT-9921",
    rows: [
      {
        invoiceNo: "#17002",
        reference: "WT-9921",
        customer: "Apex Supplies Co",
        buyDate: "11/25/2024",
        daysOpen: 23,
        activityType: "Pmt",
        appliedAR: 22750.0,
        appliedAdvance: 20475.0,
        appliedFee: 195.65,
        feePct: 0.86,
        reserveAmount: -195.65,
      },
      {
        invoiceNo: "#17003",
        reference: "WT-9922",
        customer: "Apex Supplies Co",
        buyDate: "11/26/2024",
        daysOpen: 22,
        activityType: "Pmt",
        appliedAR: 18500.0,
        appliedAdvance: 16650.0,
        appliedFee: 159.1,
        feePct: 0.86,
        reserveAmount: -159.1,
      },
    ],
    total: {
      appliedAR: 41250.0,
      appliedAdvance: 37125.0,
      appliedFee: 354.75,
      reserveAmount: -354.75,
    },
  },
  {
    date: "12/20/2024",
    type: "Buy",
    description: "Invoice Purchase",
    invoiceNo: "#6110",
    reference: "PO-44321",
    rows: [
      {
        invoiceNo: "#6110",
        reference: "PO-44321",
        customer: "Global Traders Inc",
        buyDate: "12/20/2024",
        daysOpen: 0,
        activityType: "Held",
        appliedAR: 55000.0,
        appliedAdvance: 49500.0,
        appliedFee: 0.0,
        feePct: 0.9,
        reserveAmount: 5500.0,
      },
      {
        invoiceNo: "#6111",
        reference: "PO-44322",
        customer: "Global Traders Inc",
        buyDate: "12/20/2024",
        daysOpen: 0,
        activityType: "Held",
        appliedAR: 32000.0,
        appliedAdvance: 28800.0,
        appliedFee: 0.0,
        feePct: 0.9,
        reserveAmount: 3200.0,
      },
      {
        invoiceNo: "#6112",
        reference: "PO-44323",
        customer: "Global Traders Inc",
        buyDate: "12/20/2024",
        daysOpen: 0,
        activityType: "N/F",
        appliedAR: 18750.0,
        appliedAdvance: 16875.0,
        appliedFee: 161.25,
        feePct: 0.86,
        reserveAmount: -161.25,
      },
    ],
    total: {
      appliedAR: 105750.0,
      appliedAdvance: 95175.0,
      appliedFee: 161.25,
      reserveAmount: 8538.75,
    },
  },
  {
    date: "12/22/2024",
    type: "Cash",
    description: "ACH Payment",
    invoiceNo: "#17210",
    reference: "ACH-5544",
    rows: [
      {
        invoiceNo: "#17210",
        reference: "ACH-5544",
        customer: "Bright Solutions LLC",
        buyDate: "12/01/2024",
        daysOpen: 21,
        activityType: "Pmt",
        appliedAR: 9800.0,
        appliedAdvance: 8820.0,
        appliedFee: 84.28,
        feePct: 0.86,
        reserveAmount: -84.28,
      },
      {
        invoiceNo: "#17211",
        reference: "ACH-5545",
        customer: "Bright Solutions LLC",
        buyDate: "12/02/2024",
        daysOpen: 20,
        activityType: "O/P",
        appliedAR: 7650.0,
        appliedAdvance: 6885.0,
        appliedFee: 65.79,
        feePct: 0.86,
        reserveAmount: -65.79,
      },
    ],
    total: {
      appliedAR: 17450.0,
      appliedAdvance: 15705.0,
      appliedFee: 150.07,
      reserveAmount: -150.07,
    },
  },
  {
    date: "12/26/2024",
    type: "Buy",
    description: "Spot Purchase",
    invoiceNo: "#6250",
    reference: "SP-7781",
    rows: [
      {
        invoiceNo: "#6250",
        reference: "SP-7781",
        customer: "Nexus Hardware",
        buyDate: "12/26/2024",
        daysOpen: 0,
        activityType: "Held",
        appliedAR: 71200.0,
        appliedAdvance: 64080.0,
        appliedFee: 0.0,
        feePct: 0.9,
        reserveAmount: 7120.0,
      },
    ],
    total: {
      appliedAR: 71200.0,
      appliedAdvance: 64080.0,
      appliedFee: 0.0,
      reserveAmount: 7120.0,
    },
  },
  {
    date: "12/28/2024",
    type: "Cash",
    description: "Check Payment",
    invoiceNo: "#17450",
    reference: "CHK-0092",
    rows: [
      {
        invoiceNo: "#17450",
        reference: "CHK-0092",
        customer: "Summit Retail Group",
        buyDate: "12/05/2024",
        daysOpen: 23,
        activityType: "Pmt",
        appliedAR: 33600.0,
        appliedAdvance: 30240.0,
        appliedFee: 288.96,
        feePct: 0.86,
        reserveAmount: -288.96,
      },
      {
        invoiceNo: "#17451",
        reference: "CHK-0093",
        customer: "Summit Retail Group",
        buyDate: "12/06/2024",
        daysOpen: 22,
        activityType: "Pmt",
        appliedAR: 28900.0,
        appliedAdvance: 26010.0,
        appliedFee: 248.54,
        feePct: 0.86,
        reserveAmount: -248.54,
      },
      {
        invoiceNo: "#17452",
        reference: "CHK-0094",
        customer: "Summit Retail Group",
        buyDate: "12/07/2024",
        daysOpen: 21,
        activityType: "N/F",
        appliedAR: 15400.0,
        appliedAdvance: 13860.0,
        appliedFee: 132.44,
        feePct: 0.86,
        reserveAmount: -132.44,
      },
    ],
    total: {
      appliedAR: 77900.0,
      appliedAdvance: 70110.0,
      appliedFee: 669.94,
      reserveAmount: -669.94,
    },
  },
];

export const chargeBackRows = [
  {
    customer: "Global Application Solutions",
    rows: [
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: null,
        paidOn: 0,
        colNo: "",
        giveBack: 5050,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
    ],
    total: {
      amountPaid: null,
      giveBack: 5050,
      chargeBack: 12000.0,
    },
  },
  {
    customer: "Global Application Solutions",
    rows: [
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "5050",
        giveBack: 2020,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "5050",
        giveBack: null,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "5050",
        giveBack: 3030,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
    ],
    total: {
      amountPaid: 12000.0,
      giveBack: 5050,
      chargeBack: 12000.0,
    },
  },
  {
    customer: "Global Application Solutions",
    rows: [
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: null,
        paidOn: 0,
        colNo: "",
        giveBack: 4040,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
    ],
    total: {
      amountPaid: null,
      giveBack: 4040,
      chargeBack: 12000.0,
    },
  },
  {
    customer: "Global Application Solutions",
    rows: [
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "5050",
        giveBack: 1212,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "",
        giveBack: null,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "",
        giveBack: 8523,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
    ],
    total: {
      amountPaid: 5000.0,
      giveBack: 9735,
      chargeBack: 12000.0,
    },
  },
  {
    customer: "Global Application Solutions",
    rows: [
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "5050",
        giveBack: null,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "",
        giveBack: null,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
      {
        posted: "2/25/2026",
        invoiceNo: "16808",
        purchased: "2/25/2026",
        buyNo: "",
        invoiceAmount: 12000.0,
        amountPaid: 12000.0,
        paidOn: 0,
        colNo: "",
        giveBack: 5412,
        chargeBack: 12000.0,
        writeOffer: null,
        osDescription: "EOP charge backs",
      },
    ],
    total: {
      amountPaid: 8000.0,
      giveBack: 5412,
      chargeBack: 12000.0,
    },
  },
];
export const chargeBackColumns = [
  "Customer",
  "Posted",
  "Invoice#",
  "Purchased",
  "Buy#",
  "Invoice Amount",
  "Amount Paid",
  "Paid On",
  "Col#",
  "Give Back",
  "Charge Back",
  "Write Offer",
  "O/S Description",
];
export const purchaseSummaryColumns = [
  "Client",
  "Customer",
  "Debit Count",
  "Debit Amount",
  "Credit Count",
  "Credit Amount",
  "Amount Paid",
  "Total Amount",
];
export const purchaseSummaryRows = {
  client: "Tek Tree LLC",
  rows: [
    {
      customer: "4 Consulting, Inc",
      debitCount: 1,
      debitAmount: 10400.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 10400.0,
    },
    {
      customer: "4 Consulting, Inc",
      debitCount: 1,
      debitAmount: 10400.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 10400.0,
    },
    {
      customer: "4 Consulting, Inc",
      debitCount: 1,
      debitAmount: 10400.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 10400.0,
    },
    {
      customer: "4 Consulting, Inc",
      debitCount: 1,
      debitAmount: 10400.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 10400.0,
    },
    {
      customer: "4 Consulting, Inc",
      debitCount: 1,
      debitAmount: 10400.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 10400.0,
    },
    {
      customer: "Nexus Hardware",
      debitCount: 2,
      debitAmount: 18750.0,
      creditCount: 1,
      creditAmount: 5000.0,
      amountPaid: 13750.0,
      totalAmount: 18750.0,
    },
    {
      customer: "Nexus Hardware",
      debitCount: 2,
      debitAmount: 18750.0,
      creditCount: 1,
      creditAmount: 5000.0,
      amountPaid: 13750.0,
      totalAmount: 18750.0,
    },
    {
      customer: "Apex Supplies Co",
      debitCount: 3,
      debitAmount: 22500.0,
      creditCount: 2,
      creditAmount: 8000.0,
      amountPaid: 14500.0,
      totalAmount: 22500.0,
    },
    {
      customer: "Apex Supplies Co",
      debitCount: 3,
      debitAmount: 22500.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 22500.0,
    },
    {
      customer: "Bright Solutions",
      debitCount: 1,
      debitAmount: 9800.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 9800.0,
    },
    {
      customer: "Bright Solutions",
      debitCount: 1,
      debitAmount: 9800.0,
      creditCount: 1,
      creditAmount: 3200.0,
      amountPaid: 6600.0,
      totalAmount: 9800.0,
    },
    {
      customer: "Global Traders",
      debitCount: 4,
      debitAmount: 55000.0,
      creditCount: 2,
      creditAmount: 12000.0,
      amountPaid: 43000.0,
      totalAmount: 55000.0,
    },
    {
      customer: "Global Traders",
      debitCount: 4,
      debitAmount: 55000.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 55000.0,
    },
    {
      customer: "Summit Retail",
      debitCount: 2,
      debitAmount: 33600.0,
      creditCount: 1,
      creditAmount: 9000.0,
      amountPaid: 24600.0,
      totalAmount: 33600.0,
    },
    {
      customer: "Summit Retail",
      debitCount: 2,
      debitAmount: 33600.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 33600.0,
    },
    {
      customer: "TechVision Ltd",
      debitCount: 1,
      debitAmount: 71200.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 71200.0,
    },
    {
      customer: "TechVision Ltd",
      debitCount: 1,
      debitAmount: 71200.0,
      creditCount: 1,
      creditAmount: 20000.0,
      amountPaid: 51200.0,
      totalAmount: 71200.0,
    },
    {
      customer: "Phone Infotech",
      debitCount: 2,
      debitAmount: 14385.0,
      creditCount: null,
      creditAmount: null,
      amountPaid: null,
      totalAmount: 14385.0,
    },
    {
      customer: "Phone Infotech",
      debitCount: 2,
      debitAmount: 14385.0,
      creditCount: 1,
      creditAmount: 4000.0,
      amountPaid: 10385.0,
      totalAmount: 14385.0,
    },
  ],
  grandTotal: {
    debitAmount: 35000.0,
    totalAmount: 35000.0,
  },
};
